import { Extension } from '@tiptap/core';
import { Plugin } from 'prosemirror-state';
import { editorStateStore } from '../../stores/editorsStore';
import { getSectionDisplayName } from '../../components/editors/spec/blocks/blockDefinitions';

export const DuplicateSectionChecker = Extension.create({
  name: 'duplicateSectionChecker',

  addOptions() {
    return {
      onUpdate: () => {},
    };
  },

  addProseMirrorPlugins() {
    const options = this.options;
    
    return [
      new Plugin({
        view(editorView) {
          // Check on initialization
          const initialDuplicates = checkForDuplicateSections(editorView.state.doc);
          
          // Update the store with initial state
          editorStateStore.update(state => ({
            ...state,
            duplicateSections: initialDuplicates
          }));
          
          // Call the callback with initial state
          options.onUpdate(initialDuplicates);
          
          return {
            update: (view, prevState) => {
              // Only check if document has changed
              if (view.state.doc.eq(prevState.doc)) {
                return;
              }

              const duplicates = checkForDuplicateSections(view.state.doc);
              
              // Update the store with duplicate section information
              editorStateStore.update(state => ({
                ...state,
                duplicateSections: duplicates
              }));

              // Call the optional callback
              options.onUpdate(duplicates);
            },
          };
        },
      }),
    ];
  },
});

function checkForDuplicateSections(doc) {
  const sectionCounts = new Map();
  const duplicates = [];

  // Section types that are allowed to appear multiple times
  const allowedMultiples = ['subheading', 'idf-heading'];

  // Traverse the document and count each section type
  doc.descendants((node) => {
    if (node.type.name === 'heading' && node.attrs.sectionType) {
      const sectionType = node.attrs.sectionType;
      // Skip section types that are allowed to appear multiple times
      if (allowedMultiples.includes(sectionType)) {
        return;
      }
      const count = sectionCounts.get(sectionType) || 0;
      sectionCounts.set(sectionType, count + 1);
    }
  });

  // Find all sections that appear more than once
  for (const [sectionType, count] of sectionCounts.entries()) {
    if (count > 1) {
      // Get the display name for the section from blockDefinitions
      const displayName = getSectionDisplayName(sectionType);
      duplicates.push({
        sectionType,
        displayName,
        count
      });
    }
  }

  return duplicates;
}